/* ============================================================
   PLP-004 (A/B test) — collection tabs for collection.plp_redesign-all.

   The template stacks several "ET - Collection Header + ET - Collection
   Grid" pairs (Dubbel / Enkel / Stapel). This turns them into tabs:

     Alles   -> every pair, one after the other (default)
     <name>  -> only that pair

   Runs only for the test cohort (body.test-plp-004); otherwise the page
   is left exactly as it is today.
   ============================================================ */
(function () {
  var TEST_CLASS = 'test-plp-004';
  var OFF_CLASS = 'et-plp-group--off';

  if (window.__etPlp004TabsInit) return;
  window.__etPlp004TabsInit = true;

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* The cohort class is set by the A/B tool, which may run after us. */
  function whenInTest(fn) {
    if (document.body.classList.contains(TEST_CLASS)) {
      fn();
      return;
    }
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function () {
      if (document.body.classList.contains(TEST_CLASS)) {
        observer.disconnect();
        fn();
      }
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* "Dubbel Series" -> "Dubbel" (matches the tab labels in the design). */
  function shorten(text) {
    return String(text).replace(/\s+/g, ' ').trim().replace(/\s+series?$/i, '');
  }

  function labelFor(header, index) {
    if (header) {
      var host = header.querySelector('[data-tab-label]');
      var explicit = host && host.getAttribute('data-tab-label');
      if (explicit && explicit.trim()) return explicit.trim();

      var title = header.querySelector('.et-collection-header__title');
      if (title && shorten(title.textContent)) return shorten(title.textContent);
    }
    return 'Serie ' + (index + 1);
  }

  /* Each grid section, together with the ET - Collection Header directly
     above it (the pair is what a tab shows or hides). */
  function collectGroups() {
    return qsa('[id^="shopify-section-"].et-collection-grid').map(function (grid, index) {
      var previous = grid.previousElementSibling;
      var header =
        previous && previous.classList.contains('et-collection-header-section') ? previous : null;
      return { grid: grid, header: header, label: labelFor(header, index) };
    });
  }

  function tabHtml(value, text, active) {
    return (
      '<button type="button" class="et-plp-tab' + (active ? ' is-active' : '') + '"' +
      ' data-tab="' + value + '" aria-pressed="' + (active ? 'true' : 'false') + '">' +
      escapeHtml(text) +
      '</button>'
    );
  }

  function init(mount) {
    var controls = mount.closest('[data-plp-controls]');
    if (!controls) return;

    var groups = collectGroups();
    if (groups.length < 2) return;

    /* Lift the controls out of the first grid section, so switching that
       section off does not take the bar with it. */
    var bar = document.createElement('div');
    bar.className = 'et-plp-004-bar';
    var inner = document.createElement('div');
    inner.className = 'et-plp-004-bar__inner et-container';
    bar.appendChild(inner);

    var anchor = groups[0].header || groups[0].grid;
    anchor.parentNode.insertBefore(bar, anchor);
    inner.appendChild(controls);

    /* Same for the drawer the Filters button opens — it lives in that first
       section too. It is position:fixed, so the bar is a fine host; carry the
       section's button colours over by hand since they were scoped to it. */
    var drawer = groups[0].grid.querySelector('[data-filters]');
    if (drawer) {
      var scoped = window.getComputedStyle(groups[0].grid);
      ['--et-grid-btn-bg', '--et-grid-btn-hover'].forEach(function (name) {
        var value = scoped.getPropertyValue(name);
        if (value && value.trim()) drawer.style.setProperty(name, value.trim());
      });
      bar.appendChild(drawer);
    }

    var html = tabHtml('all', mount.getAttribute('data-all-label') || 'Alles', true);
    groups.forEach(function (group, index) {
      html += tabHtml(String(index), group.label, false);
    });
    mount.innerHTML = html;
    mount.hidden = false;

    function select(value) {
      qsa('[data-tab]', mount).forEach(function (button) {
        var on = button.getAttribute('data-tab') === value;
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      groups.forEach(function (group, index) {
        var on = value === 'all' || value === String(index);
        group.grid.classList.toggle(OFF_CLASS, !on);
        if (group.header) group.header.classList.toggle(OFF_CLASS, !on);
      });

      /* Let the filter controller drop the hidden cards from its counts. */
      document.dispatchEvent(new CustomEvent('et:plp-groups-changed'));
    }

    mount.addEventListener('click', function (e) {
      var button = e.target.closest('[data-tab]');
      if (button) select(button.getAttribute('data-tab'));
    });

    select('all');
  }

  ready(function () {
    var mount = document.querySelector('[data-plp-tabs]');
    if (!mount) return;
    whenInTest(function () {
      init(mount);
    });
  });
})();
